export default "__VITE_ASSET__BsMg0oYY__"